module.exports = __webpack_public_path__ + "img/place19.1bc86e1f.jpg";